module.exports = __webpack_public_path__ + "img/28.eebe56f7.jpg";